<template>
  <div :data-category="block.category" class="full-content-block bg-neutral-50 p-4 rounded-lg shadow-md mb-5">
    <div class="flex items-center space-x-2 mb-2">
      <!-- Competitor Logo matching the sidebar design -->
      <div
        :class="[
          'w-8 h-8 rounded-full flex items-center justify-center',
          competitorInfo ? competitorInfo.backgroundColor : block.logoBgColor,
          competitorInfo ? competitorInfo.textColor : block.logoTextColor,
        ]"
      >
        {{ competitorInfo ? competitorInfo.abbreviation : block.initials }}
      </div>
      <div>
        <span class="text-lg font-semibold">{{ block.companyName }}</span>
        <button class="bg-violet-700 text-white px-3 py-1 ml-3 rounded cursor-default">
          {{ block.incent }}
        </button>
        <button
          v-for="(tag, index) in block.tags"
          :key="index"
          class="bg-violet-200 text-black px-3 py-1 ml-2 rounded cursor-default"
        >
          {{ tag }}
        </button>
      </div>
    </div>
    <div class="text-xl font-bold mb-3">{{ block.title }}</div>
    <div class="flex flex-wrap gap-4 mb-4">
      <div v-for="(image, index) in block.images" :key="index">
        <img
          :src="image.src"
          @click="openFullView(image.src)"
          @error="handleImageError(image)"
          :alt="image.alt || 'Fallback image'"
          class="w-56 h-32 object-cover rounded-lg shadow-md cursor-pointer"
        />
      </div>
      <div class="bg-white p-4 rounded-lg shadow text-left flex-1">
        <h3 class="text-base mb-1">
          Subject: <span class="font-bold">{{ block.reference }}</span>
        </h3>
        <h3 class="text-base mb-1">
          Date: <span class="font-bold">{{ formatDate(block.date) }}</span>
        </h3>
        <h3 class="text-base mb-1">
          Category: <span class="font-bold">{{ block.collection }}</span>
        </h3>
        <div v-if="block.description" class="mt-3 text-gray-700 text-sm">
          {{ block.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useMainStore } from '../stores/useMainStore';

export default {
  name: 'FullContentBlock',
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const mainStore = useMainStore();

    // Compute competitor info based on matching company name/category.
    const competitorInfo = computed(() => {
      return mainStore.sidebarItems.find((item) => {
        return item.name && item.name.toLowerCase().replace(/\s/g, '') === props.block.category;
      });
    });

    const openFullView = (imageSrc) => {
      mainStore.openFullView(imageSrc);
    };
    const handleImageError = (image) => {
      image.error = true;
      if (image.fallback) {
        image.src = image.fallback;
      }
    };
    return {
      openFullView,
      handleImageError,
      competitorInfo,
    };
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${day}.${month}.${year} at ${hours}:${minutes}`;
    },
  },
};
</script>
